import React, { useState } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { ContentSpacing } from '@estee/elc-base-theme';

import { classes } from '~utils/ClassNames';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';
import IImageWrapper from './IImageWrapper';

const Container = styled.a`
    max-width: 30%;
    border-bottom: none;
    margin-right: ${ContentSpacing.space12};
    cursor: pointer;
    position: relative;

    [dir='rtl'] & {
        margin-left: ${ContentSpacing.space12};
    }
`;

const Image = styled.img`
    max-height: 100%;
    max-width: 100%;
    margin: auto;
    user-select: none;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;

    &.loaded {
        opacity: 1;
    }
`;

export const ImageWrapper = observer((props: IImageWrapper) => {
    const { className, thumb, altThumb = [], alt, productUrl } = props;
    const [src, setSrc] = useState(thumb);
    const [loading, setLoading] = useState(true);
    const [altSrcIndex, setAltSrcIndex] = useState(0);

    const { redirectClick } = diContainer.get(serviceNames.cartSidebarViewController);

    const imageClass = loading ? '' : 'loaded';
    const imageContainerClass = classes('cart-item-image', className);

    const onError = () => {
        setLoading(true);
        if (altSrcIndex <= altThumb.length) {
            setSrc(altThumb[altSrcIndex]);
            setAltSrcIndex(altSrcIndex + 1);
        }
    };

    const onLoad = () => setLoading(false);
    const onClick = () => !!productUrl && redirectClick(productUrl);

    return (
        <Container onClick={onClick} className={imageContainerClass} tabIndex={0}>
            <Image className={imageClass} src={src} alt={alt} onError={onError} onLoad={onLoad} />
        </Container>
    );
});
